import { DbInstance } from '@shared/types/firebase';
import { getFirestore } from 'firebase/firestore';
import { getDatabase } from 'firebase/database';
import { app } from '@app/providers/firebase';

import accounting from '@services/db/accounting';
import customer from '@services/db/customer';
import helm from '@services/db/helm';
import inventory from '@services/db/inventory';
import materialMappings from '@services/db/materialMappings';
import order from '@services/db/orders';
import part from '@services/db/parts';
import purchaseOrder from '@services/db/purchaseOrders';
import personnel from '@services/db/personnel';
import qualityAssurance from '@services/db/qualityAssurance';
import realtime from '@services/db/realtime';
import vacation from '@services/db/vacation';
import vendor from '@services/db/vendor';
import { isStagingSite, useTestData } from '@lib/util/site';
import { isDevSite } from '@lib/util/site';
import { includes } from 'lodash-es';

const shouldUseProdDataInDev = () => localStorage.getItem('useProdDataInDev') === 'true';

let prodDbLogged = false;
let devDbLogged = false;

export const getDb = (env: 'default' | 'prod' | 'dev' | 'staging' | 'backup' | null = null) => {
  if (env === 'staging' || (env === null && isStagingSite())) return getFirestore(app, 'staging-db')
  if (env === 'backup') return getFirestore(app, 'backup-db');
  if (env === 'dev' || (env === null && isDevSite())) {
    // Check if user wants to use production data in dev
    if (shouldUseProdDataInDev()) {
      if (!prodDbLogged) { console.log('Dev site using PRODUCTION database (useProdDataInDev enabled)'); prodDbLogged = true; }
      return getFirestore(app);
    }
    if (!devDbLogged) { console.log('Dev site using dev-db'); devDbLogged = true; }
    return getFirestore(app, 'dev-db');
  }
  if (useTestData) return getFirestore(app, 'staging-db');
  
  if (includes(['default', 'prod'], env)) return getFirestore(app);
  // FALLBACK: use default db in any other case. This will be our production database 
  // to mitigate backend config and authentication issues.
  return getFirestore(app);
};

export const getDbByName = (name: string) => {
  return getFirestore(app, name);
}

const db: DbInstance = {
  firestore: getDb(),
  database: getDatabase(app),
  accounting,
  customer,
  helm,
  inventory,
  materialMappings,
  order,
  part,
  purchaseOrder,
  personnel,
  qualityAssurance,
  realtime,
  vacation,
  vendor,
};

export default db;